/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore from './store';
import Root from './containers/Root';

export const index = () => {
  const root = document.getElementById('root');

  const store = configureStore();
  const render = App => {
    ReactDOM.render(
      <AppContainer>
        <App store={store} />
      </AppContainer>,
      root
    );
  };

  render(Root);

  // Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('./containers/Root', () => {
      const NextRoot = require('./containers/Root').default;
      render(NextRoot);
    });
  }
};



// WEBPACK FOOTER //
// ./src/modules/bucket/index.js